// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import axios from "axios";
import { encryptHeader } from "../utils/encryptHeader";
const API_ENDPOINT = require("../config/server");
const { setSession } = require("../utils/sessionstore");
const { getSession } = require("../utils/sessionstore");

export async function getSlidingCardsSalesContentAPI(payload) {
  try {
    let formattedPayload = {
      Dashboard_Details: {
        Dashboard_Name: "Lobby",
        Dashboard_Version: "V1",
        API_Route: "GET_CLIENT_CONTENT",
        Method: "POST",
      },

      Parameters: {
        data: payload,
      },
    };

    const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

    const axiosoptions = {
      url: `${API_ENDPOINT}`,
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        session_id: getSession("session_id"),
        Authorization: `Bearer ${encryptedHeader}`,
        "IV":iv,
        'Accept-Encoding': 'identity'
      },
      data: formattedPayload,
      withCrendentials: true,
    };

    const response = await axios(axiosoptions);
    return response.data;
  } catch (error) {
    console.log(error);
  }
}